module.exports = __webpack_public_path__ + "img/4@3x.96a9d144.png";